import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from 'antd';

import { AdditionalDataSectionForm, PaymentMethodSectionForm } from './StepFourFormProvider';

import { CreditCardsInsured, SelectOption } from '../../../../../../../../../shared/interfaces';
import { UploadFile } from 'antd/lib';

interface StepFourFormContextProps {
  additionalDataFormValues:           AdditionalDataSectionForm | undefined;
  setAdditionalDataFormValues:        Dispatch<SetStateAction<AdditionalDataSectionForm | undefined>>;

  additionalDataSectionForm:          FormInstance<AdditionalDataSectionForm>;

  errorCreditCardMessage:             string;
  setErrorCreditCardMessage:          Dispatch<SetStateAction<string>>;

  inspectionList:                     Array<SelectOption>;

  isLoadingInspectionList:            boolean;
  isLoadingUseList:                   boolean;
  isLoadingTrackersList:              boolean;

  listCreditCardInsured:              CreditCardsInsured | undefined;
  setListCreditCardInsured:           Dispatch<SetStateAction<CreditCardsInsured | undefined>>;

  methodSelectedFromStepThree:        any;
  setMethodSelectedFromStepThree:     Dispatch<SetStateAction<any>>;

  paymentMethodFormValues:            PaymentMethodSectionForm | undefined;
  setPaymentMethodFormValues:         Dispatch< SetStateAction<PaymentMethodSectionForm | undefined>>;

  paymentMethodSectionForm:           FormInstance<PaymentMethodSectionForm>;
  
  tabsSectionForm:                    FormInstance<any>;

  trackersList:                       Array<SelectOption>;

  useList:                            Array<SelectOption>;

  validitySectionForm:                FormInstance<{ validityDate: any }>;

  collateralCreditors:                Array<SelectOption>;

  fileSelect:                         UploadFile[];

  setFileSelect:                      Dispatch<SetStateAction<UploadFile[]>>;
}

export const StepFourFormContext = createContext(
  {} as StepFourFormContextProps
);
